import React, { useState, useEffect } from "react";
import AgeVerification, { hasAgeVerificationConsent } from "./AgeVerification";

interface AgeVerificationGateProps {
  children: React.ReactNode;
}

const AgeVerificationGate: React.FC<AgeVerificationGateProps> = ({
  children,
}) => {
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user has already consented
    const hasConsent = hasAgeVerificationConsent();
    setIsVerified(hasConsent);
    setLoading(false);
  }, []);

  const handleVerified = () => {
    setIsVerified(true);
  };

  // Show loading state briefly to prevent flash
  if (loading) {
    return null;
  }

  // Show age verification if not verified
  if (!isVerified) {
    return <AgeVerification onVerified={handleVerified} />;
  }

  // Show children if verified
  return <>{children}</>;
};

export default AgeVerificationGate;
